import CopyPurple from "static/images/CopyPurple.svg";

type CopycodeProps = {
  label: string;
  value: string;
  onCopy: () => void;
};

export const Copycode = ({ label, value, onCopy }: CopycodeProps) => {
  return (
    <div className=" t-h-10 t-border t-border-dashed t-border-neutral-10 t-rounded t-bg-surface-lighter-grey t-py-2.5 t-px-3 t-flex t-items-center t-justify-between">
      <div className="t-flex t-items-center t-gap-1">
        <div className="t-text-body-sm t-text-text-30">{label}:</div>
        <div className="t-text-body-sm t-text-text-100 t-truncate">{value}</div>
      </div>
      <img
        onClick={onCopy}
        src={CopyPurple}
        alt="copy icon"
        className="t-order-2 t-cursor-pointer"
      />
    </div>
  );
};
